import { forwardRef, HTMLAttributes } from 'react'
import { Slot } from '@radix-ui/react-slot'
import { omit } from 'lodash'

import { cn } from '@/lib/utils'

export type SectionProps = HTMLAttributes<HTMLDivElement> & {
  asChild?: boolean
}

const Section = forwardRef<HTMLDivElement, SectionProps>(
  ({ asChild, className, ...props }, ref) => {
    const Component = asChild ? Slot : 'section'

    return (
      <Component
        ref={ref}
        className={cn(
          'bg-transparent dark:bg-section-backgroud-dark',
          className
        )}
        {...omit(props, [
          'acfe_flexible_layout_title',
          'acfe_flexible_layout_toggle',
          'dark_overlay'
        ])}
      />
    )
  }
)

export default Section
